
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sfmc",
      function () {
        return require("private-next-pages/destinations/sfmc.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sfmc"])
      });
    }
  